// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiPermissionsByGraphFolderIdRemoveData, DeleteApiPermissionsByGraphFolderIdRemoveErrors, DeleteApiPermissionsByGraphFolderIdRemoveResponses, GetApiGraphFoldersData, GetApiGraphFoldersErrors, GetApiGraphFoldersResponses, GetApiGraphUsersData, GetApiGraphUsersErrors, GetApiGraphUsersResponses, GetApiLicenseCheckData, GetApiLicenseCheckErrors, GetApiLicenseCheckResponses, GetApiLicenseCurrentData, GetApiLicenseCurrentErrors, GetApiLicenseCurrentResponses, GetApiLicenseVersionData, GetApiLicenseVersionErrors, GetApiLicenseVersionResponses, GetApiPermissionsByGraphFolderIdData, GetApiPermissionsByGraphFolderIdErrors, GetApiPermissionsByGraphFolderIdResponses, PostApiPermissionsApplyAllData, PostApiPermissionsApplyAllErrors, PostApiPermissionsApplyAllResponses, PostApiPermissionsApplySelectedData, PostApiPermissionsApplySelectedErrors, PostApiPermissionsApplySelectedResponses, PostApiPermissionsByGraphFolderIdAddData, PostApiPermissionsByGraphFolderIdAddErrors, PostApiPermissionsByGraphFolderIdAddResponses, PutApiPermissionsByGraphFolderIdUpdateData, PutApiPermissionsByGraphFolderIdUpdateErrors, PutApiPermissionsByGraphFolderIdUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getApiGraphFolders = <ThrowOnError extends boolean = false>(options?: Options<GetApiGraphFoldersData, ThrowOnError>) => (options?.client ?? client).get<GetApiGraphFoldersResponses, GetApiGraphFoldersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/Graph/folders',
    ...options
});

export const getApiGraphUsers = <ThrowOnError extends boolean = false>(options?: Options<GetApiGraphUsersData, ThrowOnError>) => (options?.client ?? client).get<GetApiGraphUsersResponses, GetApiGraphUsersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/Graph/users',
    ...options
});

export const getApiLicenseCheck = <ThrowOnError extends boolean = false>(options?: Options<GetApiLicenseCheckData, ThrowOnError>) => (options?.client ?? client).get<GetApiLicenseCheckResponses, GetApiLicenseCheckErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/License/check',
    ...options
});

export const getApiLicenseCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetApiLicenseCurrentData, ThrowOnError>) => (options?.client ?? client).get<GetApiLicenseCurrentResponses, GetApiLicenseCurrentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/License/current',
    ...options
});

export const getApiLicenseVersion = <ThrowOnError extends boolean = false>(options?: Options<GetApiLicenseVersionData, ThrowOnError>) => (options?.client ?? client).get<GetApiLicenseVersionResponses, GetApiLicenseVersionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/License/version',
    ...options
});

export const getApiPermissionsByGraphFolderId = <ThrowOnError extends boolean = false>(options: Options<GetApiPermissionsByGraphFolderIdData, ThrowOnError>) => (options.client ?? client).get<GetApiPermissionsByGraphFolderIdResponses, GetApiPermissionsByGraphFolderIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/Permissions/{graphFolderId}',
    ...options
});

export const postApiPermissionsApplyAll = <ThrowOnError extends boolean = false>(options?: Options<PostApiPermissionsApplyAllData, ThrowOnError>) => (options?.client ?? client).post<PostApiPermissionsApplyAllResponses, PostApiPermissionsApplyAllErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/Permissions/apply-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiPermissionsApplySelected = <ThrowOnError extends boolean = false>(options?: Options<PostApiPermissionsApplySelectedData, ThrowOnError>) => (options?.client ?? client).post<PostApiPermissionsApplySelectedResponses, PostApiPermissionsApplySelectedErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/Permissions/apply-selected',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiPermissionsByGraphFolderIdAdd = <ThrowOnError extends boolean = false>(options: Options<PostApiPermissionsByGraphFolderIdAddData, ThrowOnError>) => (options.client ?? client).post<PostApiPermissionsByGraphFolderIdAddResponses, PostApiPermissionsByGraphFolderIdAddErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/Permissions/{graphFolderId}/add',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiPermissionsByGraphFolderIdRemove = <ThrowOnError extends boolean = false>(options: Options<DeleteApiPermissionsByGraphFolderIdRemoveData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiPermissionsByGraphFolderIdRemoveResponses, DeleteApiPermissionsByGraphFolderIdRemoveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/Permissions/{graphFolderId}/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiPermissionsByGraphFolderIdUpdate = <ThrowOnError extends boolean = false>(options: Options<PutApiPermissionsByGraphFolderIdUpdateData, ThrowOnError>) => (options.client ?? client).put<PutApiPermissionsByGraphFolderIdUpdateResponses, PutApiPermissionsByGraphFolderIdUpdateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/Permissions/{graphFolderId}/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
